export * from './variant-b'
